const mapExpressPaymentMethods = (paymentMethods)=>{
    return (paymentMethods !== null && paymentMethods !== void 0 ? paymentMethods : []).map((paymentMethod)=>{
        return {
            name: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name,
            psp: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.psp,
            brands: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.brands
        };
    });
};

export { mapExpressPaymentMethods };
//# sourceMappingURL=express-payment-methods.js.map
